import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import SessionForm from './SessionForm';

function NewSessionModal({ open, onClose, onSessionAdded }) {
    const handleSubmit = async () => {
        if (onSessionAdded) {
            onSessionAdded();
        }
        onClose();
    };

    return (
        <Transition appear show={open} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-[#faf8f5] dark:bg-gray-800 p-6 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title className="text-base sm:text-lg font-semibold text-gray-900 dark:text-white mb-4">
                                    Add New Session
                                </Dialog.Title>
                                
                                <SessionForm onSuccess={handleSubmit} />
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}

export default NewSessionModal; 